import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../utils/i18n';
import {STATUS_SETS} from '../../../constants/issue-types';
import SelectBoxAdapter from '../../common/SelectBoxAdapter';

export default class IssueTypeStatusSetDropdown extends React.PureComponent {
  constructor(props) {
    super(props);
    this.statusSetOptions = [
      {
        label: i18n.t('issueTypes.modal.statusSet.basic'),
        subtext: i18n.t('issueTypes.modal.statusSet.basicDescription'),
        value: STATUS_SETS.BASIC
      },
      {
        label: i18n.t('issueTypes.modal.statusSet.field'),
        subtext: i18n.t('issueTypes.modal.statusSet.fieldDescription'),
        value: STATUS_SETS.FIELD
      }
    ];
  }

  render() {
    return (
      <SelectBoxAdapter
        className="IssueTypeStatusSetDropdown"
        options={this.statusSetOptions}
        onChange={this.props.onChange}
        selectedOptions={this.props.selected}
        disabled={this.props.disabled}
      />
    );
  }
}

IssueTypeStatusSetDropdown.displayName = 'IssueTypeStatusSetDropdown';

IssueTypeStatusSetDropdown.IssueTypeStatusSets = {
  BASIC: {
    value: STATUS_SETS.BASIC
  },
  FIELD: {
    value: STATUS_SETS.FIELD
  }
};

IssueTypeStatusSetDropdown.defaultProps = {
  selected: IssueTypeStatusSetDropdown.IssueTypeStatusSets.BASIC
};

IssueTypeStatusSetDropdown.propTypes = {
  onChange: PropTypes.func,
  selected: PropTypes.object,
  disabled: PropTypes.bool
};
